var _path, _rect, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTable = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 1442 567",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M0 4a4 4 0 0 1 4-4h1434a4 4 0 0 1 4 4v54H0V4Z",
  fill: "currentColor"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 1441,
  height: 566,
  rx: 3.5,
  stroke: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  fill: "currentColor",
  d: "M1 139h1441v174H1zM1 394h1441v173H1z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M.344 312.5H1441M.344 138.5H1441M.344 393.5H1441"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 17,
  y: 102,
  width: 125,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 338,
  y: 102,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 338,
  y: 183,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 338,
  y: 207,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 338,
  y: 438,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 338,
  y: 462,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 332,
  y: 486,
  width: 58,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 338,
  y: 510,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 323,
  y: 231,
  width: 67,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 338,
  y: 255,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 323,
  y: 279,
  width: 67,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 338,
  y: 357,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 332,
  y: 534,
  width: 58,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 496,
  y: 102,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 656,
  y: 102,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 816,
  y: 102,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 976,
  y: 102,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1136,
  y: 102,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1296,
  y: 102,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 496,
  y: 183,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 656,
  y: 183,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 976,
  y: 183,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 816,
  y: 183,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1136,
  y: 183,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1296,
  y: 183,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 496,
  y: 207,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 976,
  y: 207,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 656,
  y: 207,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 816,
  y: 207,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1136,
  y: 207,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1296,
  y: 207,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 976,
  y: 438,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 496,
  y: 438,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 656,
  y: 438,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 816,
  y: 438,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 976,
  y: 462,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1136,
  y: 438,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1296,
  y: 438,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 496,
  y: 462,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 656,
  y: 462,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 970,
  y: 486,
  width: 58,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 816,
  y: 462,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1136,
  y: 462,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1296,
  y: 462,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 490,
  y: 486,
  width: 58,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 976,
  y: 510,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 650,
  y: 486,
  width: 58,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 810,
  y: 486,
  width: 58,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1130,
  y: 486,
  width: 58,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1290,
  y: 486,
  width: 58,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 961,
  y: 231,
  width: 67,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 496,
  y: 510,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 656,
  y: 510,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 816,
  y: 510,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 976,
  y: 255,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1136,
  y: 510,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1296,
  y: 510,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 481,
  y: 231,
  width: 67,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 641,
  y: 231,
  width: 67,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 961,
  y: 279,
  width: 67,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 801,
  y: 231,
  width: 67,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1121,
  y: 231,
  width: 67,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1281,
  y: 231,
  width: 67,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 496,
  y: 255,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 976,
  y: 357,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 656,
  y: 255,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 816,
  y: 255,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1136,
  y: 255,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1296,
  y: 255,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 970,
  y: 534,
  width: 58,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 481,
  y: 279,
  width: 67,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 641,
  y: 279,
  width: 67,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 801,
  y: 279,
  width: 67,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1121,
  y: 279,
  width: 67,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1281,
  y: 279,
  width: 67,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 496,
  y: 357,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 656,
  y: 357,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 816,
  y: 357,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1136,
  y: 357,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1296,
  y: 357,
  width: 52,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 490,
  y: 534,
  width: 58,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 650,
  y: 534,
  width: 58,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 810,
  y: 534,
  width: 58,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1130,
  y: 534,
  width: 58,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 1290,
  y: 534,
  width: 58,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 17,
  y: 77,
  width: 42,
  height: 19,
  rx: 2,
  fill: "currentColor"
})), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 17,
  y: 183,
  width: 34,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 17,
  y: 438,
  width: 34,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 17,
  y: 357,
  width: 99,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 17,
  y: 207,
  width: 99,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 17,
  y: 462,
  width: 125,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 17,
  y: 231,
  width: 57,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 17,
  y: 486,
  width: 125,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 17,
  y: 255,
  width: 99,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 17,
  y: 510,
  width: 125,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 17,
  y: 279,
  width: 99,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 17,
  y: 534,
  width: 125,
  height: 16,
  rx: 2,
  fill: "currentColor"
})), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 17,
  y: 411,
  width: 99,
  height: 19,
  rx: 2,
  fill: "currentColor"
})), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 17,
  y: 156,
  width: 125,
  height: 19,
  rx: 2,
  fill: "currentColor"
})), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 17,
  y: 330,
  width: 71,
  height: 19,
  rx: 2,
  fill: "currentColor"
})));
export default SvgTable;